export default __webpack_public_path__ + "34e5c8703b797ccfd133034058247a1c.svg";